/**
 * 
 * @param url 
 * @param parameterName 
 * @returns 
 */

export function getParameterByName(url: Location, parameterName: string): number | null {
    const urlObject = new URL(url.href);
    const paramValue = urlObject.searchParams.get(parameterName);

    if (paramValue === null) {
        return null;
    }

    if (paramValue === "0") {
        return 0;
    } else if (paramValue === "1") {
        return 1;
    } else {
        console.warn(`Некорректное значение параметра ${parameterName}: ${paramValue}`);
        return null;
    }
}